
export default {
  methods: {
    preventSaveLoss: function (callbackCondition) {
      if (!callbackCondition) return;

      const beforeVisit = function (e) {
        if (callbackCondition() && !confirm("You haven't saved your changes yet. Are you sure you want to leave the page?")) {
          return e.preventDefault();
        }
      };

      const beforeUnload = function () {
        if (callbackCondition()) {
          return "You haven't saved your changes yet. Are you sure you want to leave the page?"
        }
      };

      const cleanup = function () {
        $(window).off('unload', cleanup);
        // $(document).off('turbolinks:load', cleanup);
        $(window).off('beforeunload', beforeUnload);
        // $(document).off('turbolinks:before-visit', beforeVisit);
      };

      // $(document).on('turbolinks:before-visit', beforeVisit);
      $(window).on('beforeunload', beforeUnload);

      // $(document).on('turbolinks:load', cleanup);
      $(window).on('unload', cleanup);
    },
  }
}